export default {"src":"/_next/static/media/tumblr.64be577c.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};